<app-header></app-header>

<div class="mx-auto max-w-screen-lg px-4 py-8 md:px-0 md:py-2 sm:py-0">
    <ng-content></ng-content>
</div>

<app-footer-1></app-footer-1>
